import React from 'react';
import { AppComponent } from 'utils/components';

export default function Form(props: { component: AppComponent }) {
	console.warn('unimplemented', props.component);

	return <div>form</div>;
}
